<template>
  <div class="graph-area">
    <div class="select-bar">
      <div v-if="isVisible">
        <button
          v-for="(value, key) in episodeVisible"
          :key="key"
          class="toggle"
          :class="{ episodeactive: episodeVisible[key] }"
          @click="
            toggleEpisodes(key);
            episodeVisible[key] = !episodeVisible[key];
          "
        >
          {{ uppercase(key) }}
        </button>
        <button
          class="toggle"
          :class="{ entityactive: entityShow }"
          @click="
            toggleEntities();
            entityShow = !entityShow;
          "
        >
          Entities
        </button>

        <button
          class="toggle"
          :class="{ similarityactive: similarityShow }"
          @click="
            toggleSimilarities();
            similarityShow = !similarityShow;
          "
        >
          Similarties
        </button>
      </div>
    </div>

    <div class="graph"></div>

    <button
      @click="
        runGraph();
        isVisible = true;
      "
      class="run-query"
    >
      run
    </button>
    <button @click="updateGraph()" class="run-query">update</button>
  </div>
</template>

<script>
import * as d3 from "d3";
import fred from "../data/fred.json";
import rabih from "../data/rabih.json";
import christina from "../data/christina.json";
import claudia from "../data/claudia.json";
import mark from "../data/mark.json";
import ixmucane from "../data/ixmucane.json";

import { mapState } from "vuex";

export default {
  name: "this.graphLayout",
  props: {},
  data() {
    return {
      episodeVisible: {
        fred: true,
        rabih: true,
        christina: true,
        claudia: true,
        mark: true,
        ixmucane: true,
      },
      entityShow: true,
      similarityShow: true,
      Fred: fred["chunk_sequence"],
      Rabih: rabih["chunk_sequence"],
      Christina: christina["chunk_sequence"],
      Claudia: claudia["chunk_sequence"],
      Mark: mark["chunk_sequence"],
      Ixmucane: ixmucane["chunk_sequence"],
      isVisible: false,
      graph: {
        nodes: [
          {
            id: "Fred",
            name: "Fred",
            label: "Episode",
            content: "",
            group: 0,
            size: 2,
          },
          {
            id: "Rabih",
            name: "Rabih",
            label: "Episode",
            content: "",
            group: 0,
            size: 2,
          },
          {
            id: "Christina",
            name: "Christina",
            label: "Episode",
            content: "",
            group: 0,
            size: 2,
          },
          {
            id: "Claudia",
            name: "Claudia",
            label: "Episode",
            content: "",
            group: 0,
            size: 2,
          },
          {
            id: "Mark",
            name: "Mark",
            label: "Episode",
            content: "",
            group: 0,
            size: 2,
          },
          {
            id: "Ixmucane",
            name: "Ixmucane",
            label: "Episode",
            content: "",
            group: 0,
            size: 2,
          },
        ],
        links: [],
      },
    };
  },
  computed: {
    ...mapState(["similarityObject"]),
    ...mapState(["entityObject"]),
  },
  created() {},
  methods: {
    uppercase(key) {
      let string = String(key);
      string = string.charAt(0).toUpperCase() + string.slice(1);
      return string;
    },
    updateGraph() {
      // this.graph.remove();

      console.log("update");
    },
    toggleEpisodes(speakerName) {
      const node = d3.selectAll("." + speakerName + "-chunk");
      const link = d3.selectAll("." + speakerName + "-link");

      if (this.episodeVisible[speakerName] == true) {
        node.style("display", "none");
        link.style("display", "none");
      } else {
        node.style("display", "block");
        link.style("display", "block");
      }
    },
    toggleEntities() {
      const node = d3.selectAll(".entity");
      if (this.entityShow == true) {
        node.style("display", "none");
      } else {
        node.style("display", "block");
      }
      const entityLink = d3.selectAll(".entity-link");
      if (this.entityShow == true) {
        entityLink.style("display", "none");
      } else {
        entityLink.style("display", "block");
      }
    },
    toggleSimilarities() {
      const similarityLink = d3.selectAll(".similarity-link");
      if (this.similarityShow == true) {
        similarityLink.style("display", "none");
      } else {
        similarityLink.style("display", "block");
      }
    },
    runGraph() {
      d3.select(".graph")

        .append("svg")
        .attr("width", 1600)
        .attr("height", 1200);

      var svg = d3.select("svg");

      var width = svg.attr("width");
      var height = svg.attr("height");

      var entity;
      for (
        entity = 0;
        entity < this.entityObject.records.length - 1;
        entity++
      ) {
        this.graph.nodes.push({
          id: this.entityObject.records[entity]._fields[2].properties.entity_id,
          name: this.entityObject.records[entity]._fields[2].properties.name,
          label: "entity node",
          content: this.entityObject.records[entity]._fields[2].properties.text,
          group: 2,
          type: 1,
        });
      }

      var elinks;
      for (
        elinks = 0;
        elinks < this.entityObject.records.length - 1;
        elinks++
      ) {
        this.graph.links.push({
          ref: "entity-link",
          source:
            this.entityObject.records[elinks]._fields[0].properties.chunk_id,
          target:
            this.entityObject.records[elinks]._fields[2].properties.entity_id,
          distance: 80,
          type: 0,
        });
      }

      this.Fred.forEach((element) => {
        this.graph.nodes.push({
          id: element.chunk_id,
          name: element.source_file,
          label: "fred-chunk node",
          content: element.text,
          group: 1,
          size: 1,
        });
      });
      this.Rabih.forEach((element) => {
        this.graph.nodes.push({
          id: element.chunk_id,
          name: element.source_file,
          label: "rabih-chunk node",
          content: element.text,
          group: 1,
          size: 1,
        });
      });
      this.Christina.forEach((element) => {
        this.graph.nodes.push({
          id: element.chunk_id,
          name: element.source_file,
          label: "christina-chunk node",
          content: element.text,
          group: 1,
          size: 1,
        });
      });
      this.Claudia.forEach((element) => {
        this.graph.nodes.push({
          id: element.chunk_id,
          name: element.source_file,
          label: "claudia-chunk node",
          content: element.text,
          group: 1,
          size: 1,
        });
      });
      this.Mark.forEach((element) => {
        this.graph.nodes.push({
          id: element.chunk_id,
          name: element.source_file,
          label: "mark-chunk node",
          content: element.text,
          group: 1,
          size: 1,
        });
      });
      this.Ixmucane.forEach((element) => {
        this.graph.nodes.push({
          id: element.chunk_id,
          name: element.source_file,
          label: "ixmucane-chunk node",
          content: element.text,
          group: 1,
          size: 1,
        });
      });

      var a;
      for (a = 0; a < this.Fred.length - 1; a++) {
        this.graph.links.push({
          ref: "fred-link",
          source: this.Fred[a].chunk_id,
          target: this.Fred[a + 1].chunk_id,
          distance: 20,
          type: 0,
        });
      }
      var i;
      for (i = 0; i < this.Rabih.length - 1; i++) {
        this.graph.links.push({
          ref: "rabih-link",
          source: this.Rabih[i].chunk_id,
          target: this.Rabih[i + 1].chunk_id,
          distance: 20,
          type: 0,
        });
      }
      var j;
      for (j = 0; j < this.Christina.length - 1; j++) {
        this.graph.links.push({
          ref: "christina-link",
          source: this.Christina[j].chunk_id,
          target: this.Christina[j + 1].chunk_id,
          distance: 20,
          type: 0,
        });
      }
      var b;
      for (b = 0; b < this.Claudia.length - 1; b++) {
        this.graph.links.push({
          ref: "claudia-link",
          source: this.Claudia[b].chunk_id,
          target: this.Claudia[b + 1].chunk_id,
          distance: 20,
          type: 0,
        });
      }
      var c;
      for (c = 0; c < this.Mark.length - 1; c++) {
        this.graph.links.push({
          ref: "mark-link",
          source: this.Mark[c].chunk_id,
          target: this.Mark[c + 1].chunk_id,
          distance: 20,
          type: 0,
        });
      }
      var d;
      for (d = 0; d < this.Ixmucane.length - 1; d++) {
        this.graph.links.push({
          ref: "ixmucane-link",
          source: this.Ixmucane[d].chunk_id,
          target: this.Ixmucane[d + 1].chunk_id,
          distance: 20,
          type: 0,
        });
      }

      // console.log(this.entityObject.records.length);

      // console.log(this.graph.links);

      var e;
      for (e = 0; e < this.Fred.length - 1; e++) {
        this.graph.links.push({
          ref: "fred-link",
          source: "Fred",
          target: this.Fred[e].chunk_id,
          distance: 120,
          type: 0,
        });
      }
      var k;
      for (k = 0; k < this.Rabih.length - 1; k++) {
        this.graph.links.push({
          ref: "rabih-link",
          source: "Rabih",
          target: this.Rabih[k].chunk_id,
          distance: 120,
          type: 0,
        });
      }
      var l;
      for (l = 0; l < this.Christina.length - 1; l++) {
        this.graph.links.push({
          ref: "christina-link",
          source: "Christina",
          target: this.Christina[l].chunk_id,
          distance: 120,
          type: 0,
        });
      }
      var f;
      for (f = 0; f < this.Claudia.length - 1; f++) {
        this.graph.links.push({
          ref: "claudia-link",
          source: "Claudia",
          target: this.Claudia[f].chunk_id,
          distance: 120,
          type: 0,
        });
      }
      var g;
      for (g = 0; g < this.Mark.length - 1; g++) {
        this.graph.links.push({
          ref: "mark-link",
          source: "Mark",
          target: this.Mark[g].chunk_id,
          distance: 120,
          type: 0,
        });
      }
      var h;
      for (h = 0; h < this.Ixmucane.length - 1; h++) {
        this.graph.links.push({
          ref: "ixmucane-link",
          source: "Ixmucane",
          target: this.Ixmucane[h].chunk_id,
          distance: 120,
          type: 0,
        });
      }

      var s;
      for (s = 0; s < this.similarityObject.records.length - 1; s++) {
        this.graph.links.push({
          ref: "similarity-link",
          source:
            this.similarityObject.records[s]._fields[0].properties.chunk_id,
          target:
            this.similarityObject.records[s]._fields[1].properties.chunk_id,
          distance:
            this.similarityObject.records[s]._fields[2].properties.similarity,
          type: 1,
        });
      }

      var color = d3
        .scaleOrdinal()
        .domain([0, 1])
        .range([
          "rgb(196, 196, 196)",
          "rgb(104, 23, 255)",
          "rgb(243, 228, 94)",
        ]);

      var size = d3.scaleOrdinal().domain([0, 1]).range(["14", "10"]);

      var type = d3
        .scaleOrdinal()
        .domain([0, 1])
        // .range(["rgb(60, 60, 60)", "rgb(130, 130, 130)"]);
        .range(["rgb(60, 60, 60)", "rgb(93, 211, 93)"]);

      const simulation = d3
        .forceSimulation(this.graph.nodes)
        .force(
          "link",
          d3
            .forceLink()
            .id(function (d) {
              return d.id;
            })
            .links(this.graph.links)
        )

        .force("charge", d3.forceManyBody().strength(-30))
        .force("center", d3.forceCenter(width / 2, height / 2))
        .force(
          "link",
          d3
            .forceLink()
            .distance(function (d) {
              return d.distance;
            })
            .strength(2)
        )
        .on("tick", ticked);

      var link = svg
        .append("g")
        .attr("class", "links")
        .selectAll("line")
        .data(this.graph.links)
        .enter()
        .append("line")
        .attr("class", function (d) {
          return d.ref;
        })
        .attr("stroke-width", function () {
          return 1.5;
        })
        .attr("stroke", function (d) {
          return type(d.type);
        });

      var node = svg
        .append("g")
        .attr("class", "nodes")
        .selectAll("g")
        .data(this.graph.nodes)
        .enter()
        .append("g")
        // .attr("class", "node")
        .attr("class", function (d) {
          return d.label;
        })
        .call(
          d3
            .drag()
            .on("start", dragstarted)
            .on("drag", dragged)
            .on("end", dragended)
        );

      node
        .append("circle")
        .attr("fill", function (d) {
          return color(d.group);
        })
        .attr("r", function (d) {
          return size(d.size);
        });

      node
        .append("text")
        .attr("class", "name")
        .text(function (d) {
          return d.name;
        })
        .attr("x", 14)
        .attr("y", -6);

      function wrap(text, width) {
        text.each(function () {
          var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineNumber = 0,
            lineHeight = 1.1, // ems
            x = text.attr("x"),
            y = text.attr("y"),
            dy = 0, //parseFloat(text.attr("dy")),
            tspan = text
              .text(null)
              .append("tspan")
              .attr("x", x)
              .attr("y", y)
              .attr("dy", dy + "em");
          // .style("display", "block");
          while ((word = words.pop())) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text
                .append("tspan")
                .attr("x", x)
                .attr("y", y)
                .attr("dy", ++lineNumber * lineHeight + dy + "em")
                .text(word);
            }
          }
        });
      }

      node
        .append("text")
        .text(function (d) {
          return d.content;
        })
        .attr("class", "content")
        .attr("x", 14)
        .attr("y", 10)
        .call(wrap, 180)
        .style("display", "none");

      d3.selectAll(".node").on("mouseover", function () {
        d3.select(this).raise();
        d3.select(this)
          .select(".name")
          // .attr("x", 30)
          .style("fill", "rgba(255, 255, 255, 1)");
        d3.select(this)
          .select(".content")
          // .attr("x", 30)
          .style("display", "block");
        d3.select(this).select("circle").attr("r", 15);
      });

      d3.selectAll(".node").on("mouseout", function () {
        d3.select(this)
          .select(".name")
          .style("fill", "rgb(228, 228, 228, 0.4)");
        d3.select(this).selectAll(".content").style("display", "none");
        d3.select(this).select("circle").attr("r", 10);
      });

      function ticked() {
        link
          .attr("x1", function (d) {
            return d.source.x;
          })
          .attr("y1", function (d) {
            return d.source.y;
          })
          .attr("x2", function (d) {
            return d.target.x;
          })
          .attr("y2", function (d) {
            return d.target.y;
          });

        node.attr("transform", function (d) {
          return "translate(" + d.x + "," + d.y + ")";
        });
      }

      simulation.nodes(this.graph.nodes).on("tick", ticked);

      simulation.force("link").links(this.graph.links);

      function dragstarted(event, d) {
        if (!event.active) simulation.alphaTarget(0.3).restart();
        d.fx = d.x;
        d.fy = d.y;
      }

      function dragged(event, d) {
        d.fx = event.x;
        d.fy = event.y;
      }

      function dragended(event, d) {
        if (!event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      }
    },
  },
};
</script>

<style scoped>
.graph-area {
  padding-top: 30px;
  color: white;
}

button {
  background: black;
  border: 1px solid rgb(34, 34, 34);
  border-radius: 10px;
  padding: 8px 16px;
  color: white;
  margin-top: 15px;
  margin-left: 10px;
  margin-right: 10px;
}

button:hover {
  cursor: pointer;
}

.run-query:hover {
  cursor: pointer;
  background-color: palevioletred;
  color: white;
}

.entityactive {
  background-color: rgb(243, 228, 94);
  color: black;
}

.episodeactive {
  background-color: rgb(104, 23, 255);
  color: white;
}

.select-bar {
  position: fixed;
  top: 10px;
  left: 20px;
  margin-left: auto;
  margin-right: auto;
}

.similarityactive {
  background-color: rgb(93, 211, 93);
  color: black;
}
</style>
